/**
 * formatPriceDecimal
 *
 * example :
 *
 * formatPriceDecimal(price);
 * 12.00 => 12, 12.50 => 12,50
 */

export const formatPriceDecimal = function (priceParam) {
  const price = parseFloat(priceParam);
  return price.toFixed(price % 1 !== 0 ? 2 : 0).replace('.', ',');
};